import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
  compose,
  Store
} from 'redux';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';
import { reducer as alertsReducer } from './reducers/alerts/reducer';
import { reducer as cartReducer } from './reducers/cart/reducer';
import { reducer as categoriesReducer } from './reducers/categories/reducer';
import { reducer as formsReducer } from './reducers/forms/reducer';
import { reducer as prebooksReducer } from './reducers/prebooks/reducer';
import { reducer as servicesReducer } from './reducers/services/reducer';
import { reducer as userReducer } from './reducers/user/reducer';
import { reducer as calendarReducer } from './reducers/calendar/reducer';
import { reducer as vacationReducer } from './reducers/vacation/reducer';

import { Persistor, persistReducer, persistStore } from 'redux-persist';

const servicesPersistConfig = {
  key: 'services',
  storage,
  whitelist: ['filters']
};

export type AppStore = Store & { __persistor: Persistor };

export let store: AppStore | null = null;

// Put outside of the fn to create a type
export const rootReducer = combineReducers({
  calendars: calendarReducer,
  services: persistReducer(servicesPersistConfig, servicesReducer),
  user: userReducer,
  cart: cartReducer,
  forms: formsReducer,
  alerts: alertsReducer,
  categories: categoriesReducer,
  prebooks: prebooksReducer,
  vacation: vacationReducer
});

const composeEnhancers =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export default function configureStore(initialState?: any): AppStore {
  const middleware = [thunkMiddleware];
  const s = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  ) as AppStore;
  s.__persistor = persistStore(s);
  store = s;
  return s;
}
